import type {ReactElement} from 'react';
import React from 'react';
import {useIsSmallerThanBreakpointWidth} from '@Hooks/useIsSmallerThanBreakpoint';
import {SCREEN_BREAKPOINTS} from '@Libraries/responsiveness-library';
import styles from './ai-text-prompt-box-loading.module.scss';

interface AiTextsPromptBoxLoadingProps {
  isShown: boolean;
  message: string;
  invertedColors?: boolean;
  containerClasses?: string;
  hiddenEllipsis?: boolean;
}

export function AiTextPromptBoxLoading({...props}: AiTextsPromptBoxLoadingProps): ReactElement | null {
  if (!props.isShown) {
    return null;
  }

  const isModal = useIsSmallerThanBreakpointWidth(SCREEN_BREAKPOINTS.MOBILE_MODAL_ACTIVATION_BREAKPONT);

  return (
    <div className={`${props.containerClasses} `}>
      <div
        className={`
          flex-row-align-center _fit-width 
          ${styles.aiTextsLoading}  
          ${props.hiddenEllipsis ? styles.hiddenEllipsis : ''}
          ${props.invertedColors ? `${styles.invertedColors} spacing-p-0` : ''}
        `}
      >
        <div className={`${styles.aiTextsLoadingText} ${isModal ? 'body-s' : 'body-xs'}`}>{props.message}</div>
      </div>
    </div>
  );
}
